import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import "./banner.css";

function BannerEdit() {
    const { id_banner } = useParams();
    const navigate = useNavigate();

    const [availableApps] = useState(["inovy", "yess", "toca", "gass"]);

    const [formValue, setFormValue] = useState({
        title: "",
        apps: [],
        active: true,
        image_url: "",
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState(null);

    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3100";

    // === Ambil data banner berdasarkan ID ===
    const fetchData = useCallback(async () => {
        try {
            const res = await axios.get(`${API_URL}/banner/${id_banner}`);
            const data = res.data;

            setFormValue({
                title: data.title || "",
                apps: Array.isArray(data.apps) ? data.apps : [],
                active: !!data.active,
                image_url: data.image_url || "",
            });

            setPreview(data.image_url || null);
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Gagal memuat data banner", "error");
        }
    }, [id_banner, API_URL]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // === Handle input ===
    const handleChange = (e) => {
        const { name, value, files, type, checked } = e.target;

        if (type === "file" && files.length > 0) {
            const file = files[0];
            setSelectedFile(file);

            // tampilkan preview baru
            const reader = new FileReader();
            reader.onload = (ev) => setPreview(ev.target.result);
            reader.readAsDataURL(file);
        } else if (type === "checkbox" && name === "active") {
            setFormValue({ ...formValue, active: checked });
        } else if (type === "checkbox" && name.startsWith("app_")) {
            const appName = value;
            const updatedApps = checked
                ? [...formValue.apps, appName]
                : formValue.apps.filter((a) => a !== appName);
            setFormValue({ ...formValue, apps: updatedApps });
        } else {
            setFormValue({ ...formValue, [name]: value });
        }
    };

    // === Submit perubahan banner ===
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formValue.title || formValue.apps.length === 0) {
            Swal.fire("Error", "Judul dan minimal satu aplikasi wajib diisi!", "error");
            return;
        }

        const formData = new FormData();
        formData.append("title", formValue.title);
        formData.append("apps", formValue.apps.join(","));
        formData.append("active", formValue.active ? "1" : "0");
        if (selectedFile) formData.append("image", selectedFile);

        try {
            await axios.put(`${API_URL}/banner/${id_banner}`, formData);

            Swal.fire("Success", "Banner berhasil diperbarui!", "success");
            navigate("/banner");
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Terjadi kesalahan saat menyimpan data", "error");
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Administrasi</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Edit Banner</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Banner</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            {/* Judul */}
                                            <div className="form-group">
                                                <label>Judul Banner</label>
                                                <input
                                                    type="text"
                                                    name="title"
                                                    className="form-control"
                                                    placeholder="Masukkan judul banner"
                                                    value={formValue.title}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            {/* Apps (Checkbox) */}
                                            <div className="form-group">
                                                <label>Aplikasi Terkait</label>
                                                <div className="d-flex flex-wrap">
                                                    {availableApps.map((app) => (
                                                        <div
                                                            key={app}
                                                            className="form-check mr-3 mb-2"
                                                        >
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`app_${app}`}
                                                                name={`app_${app}`}
                                                                value={app}
                                                                checked={formValue.apps.includes(
                                                                    app
                                                                )}
                                                                onChange={handleChange}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`app_${app}`}
                                                            >
                                                                {app.toUpperCase()}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Upload Gambar */}
                                            <div className="form-group">
                                                <label>Gambar Banner</label>
                                                <input
                                                    type="file"
                                                    name="image"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                />

                                                {preview && (
                                                    <div className="preview-container-banner mt-3">
                                                        <img
                                                            src={preview}
                                                            alt="Preview"
                                                            className="preview-image-banner"
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            {/* Status Aktif */}
                                            <div className="form-group form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="active"
                                                    name="active"
                                                    checked={formValue.active}
                                                    onChange={handleChange}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="active"
                                                >
                                                    Aktif
                                                </label>
                                            </div>

                                            {/* Tombol */}
                                            <button type="submit" className="btn btn-info">
                                                Simpan
                                            </button>
                                            <Link to="/banner">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary ml-2"
                                                >
                                                    Batal
                                                </button>
                                            </Link>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default BannerEdit;
